import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Button, Select, message } from 'antd';
import { layout, tailLayout } from './constant';
import ApiServices from '~services';
import { Selection } from '~components';
const { Option } = Select;

const CreateClientForm = ({
  fields,
  isNew,
  id,
  isDriver,
  reload,
  onChange,
  setLoading,
  dataSelected,
}) => {
  // console.log({ dataSelected });
  console.log({ isDriver });
  const inputRef = useRef(null);
  const [groups, setGroups] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [customers, setCustomers] = useState([]);

  const getCustomers = async (Query = null) => {
    try {
      const { data } = await ApiServices.getCustomer({ Query });
      setCustomers(data.data);
    } catch (err) {
      console.error('ERR - Get Customers', err);
    }
  };

  const getDataInit = async () => {
    const [getGroup] = await Promise.all([ApiServices.getGroups(), ApiServices.getCompanies()]);
    setGroups(getGroup.data);
  };

  const getCompanies = async (query = '') => {
    const newQuery = {
      Columns: {
        title: query,
      },
    };
    try {
      const res = await ApiServices.getCompanies(query ? newQuery : null);
      if (res?.data?.data) {
        setCompanies(res?.data?.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getCustomers();
    getDataInit();

    getCompanies();
  }, []);

  const onCompareWithApi = (value, cb) => {
    if (inputRef.current) {
      clearTimeout(inputRef.current);
      cb();
    }
    inputRef.current = setTimeout(async () => {
      try {
        const { data } = await ApiServices.existsCodeUser(null, value);
        const isUsed = data;
        cb(isUsed);
      } catch (error) {
        console.error(error);
      }
    }, 1000);
  };

  const checkExistsCode = async (_, value) => {
    if (value.length > 3) {
      const ind = fields.findIndex((item) => {
        return item.name[0] === 'code';
      });
      if (isNew === false && value !== fields[ind].value) {
        try {
          const waitMe = () =>
            new Promise((resolve, reject) => {
              onCompareWithApi(value, (isUsed) => {
                if (typeof isUsed !== 'undefined') {
                  if (isUsed) reject();
                  resolve();
                }
              });
            });
          await waitMe();
        } catch (error) {
          return Promise.reject(new Error('User này đã tạo rồi !!!'));
        }
      }

      if (isNew === true) {
        try {
          const waitMe = () =>
            new Promise((resolve, reject) => {
              onCompareWithApi(value, (isUsed) => {
                if (typeof isUsed !== 'undefined') {
                  if (isUsed) reject();
                  resolve();
                }
              });
            });
          await waitMe();
        } catch (error) {
          return Promise.reject(new Error('User này đã tạo rồi !!!'));
        }
      }
    }
  };

  const createUser = async (data) => {
    let fullName = 'customer-account';
    if (data?.customerId) {
      const customerSelect = customers.find((item) => item.id === data.customerId);
      if (customerSelect) {
        fullName = customerSelect.code;
      }
    }

    const dataSend = {
      code: data.code,
      password: '123456',
      isDriver: false,
      customerId: [data?.customerId],
      companyId: data.companyId,
      arrMemberGroup: data?.arrMemberGroup,
      fullName,
    };

    try {
      const res = await ApiServices.createUser(dataSend);
      if (res.data) {
        message.success('Thêm mới Tài khoản Khách hàng thành công');
        return reload();
      } else {
        message.error('Thêm mới Tài khoản Khách hàng thất baị, vui lòng kiểm tra lại thông tin');
      }
    } catch (err) {
      message.error('Thêm mới Tài khoản Khách hàng thất baị, vui lòng kiểm tra lại thông tin');
      console.error(err);
    }
  };
  const updateUser = async (data) => {
    // console.log({ data });
    // data.id = id;
    const dataSend = {
      ...data,
      id,
      customerId: [data?.customerId],
      fullName: dataSelected.fullName || 'customer-account',
    };
    try {
      const res = await ApiServices.updateUser(id, dataSend);
      if (res.data) {
        message.success('Cập nhật Tài khoản Khách hàng thành công');
        return reload();
      } else {
        message.error('Cập nhật Tài khoản Khách hàng thất baị, vui lòng kiểm tra lại thông tin');
      }
    } catch (err) {
      message.error('Cập nhật Tài khoản Khách hàng thất baị, vui lòng kiểm tra lại thông tin');
      console.error(err);
    }
  };
  const onSubmitForm = async (value) => {
    if (isNew) {
      setLoading(true);
      await createUser(value);
      setLoading(false);
      return;
    }
    setLoading(true);
    await updateUser(value);
    setLoading(false);
  };
  return (
    <Form
      {...layout}
      name='global_state'
      onFinish={onSubmitForm}
      fields={fields}
      onFieldsChange={(_, allFields) => {
        onChange(allFields);
      }}
    >
      <Form.Item
        name='customerId'
        label='Khách hàng'
        rules={[
          {
            required: true,
            message: 'Bạn phải chọn Khách hàng',
          },
        ]}
      >
        <Selection
          data={customers}
          // labelDefault={orderDetail?.customerName}
          placeholder='Khách hàng'
          onSearch={getCustomers}
        />
      </Form.Item>
      <Form.Item
        // {...itemLayout}
        style={{ marginTop: '10px' }}
        name='code'
        label='Tên Đăng Nhập'
        rules={[
          {
            required: true,
            message: 'Bạn phải nhập Tên Đăng Nhập',
          },
          {
            validator: checkExistsCode,
          },
          {
            type: 'string',
            min: 3,
            message: 'Bạn phải nhập ít nhất 3 ký tự',
            // max: 10,
            // message: 'Tên đăng nhập tối thiểu 3 ký tự, tối đa 10 ký tự',
          },
        ]}
      >
        <Input placeholder='Tên Đăng Nhập' />
      </Form.Item>

      <Form.Item
        name='arrMemberGroup'
        label='Nhóm Thành Viên'
        rules={[
          {
            required: true,
            message: 'Bạn phải chọn Nhóm Thành Viên',
          },
        ]}
      >
        <Select mode='multiple' showArrow showSearch placeholder='Nhóm Thành Viên'>
          {groups.map(({ id, name }) => (
            <Option key={id} value={id}>
              {name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name='companyId' label='Công Ty'>
        <Selection
          labelDefault={dataSelected?.companyName || ''}
          data={companies}
          placeholder='Bạn phải chọn Công Ty'
          fieldValue='title'
          onSearch={getCompanies}
        />
      </Form.Item>

      <Form.Item {...tailLayout}>
        <Button type='primary' htmlType='submit'>
          {isNew ? 'Thêm Mới' : 'Cập nhật'}
        </Button>
      </Form.Item>
    </Form>
  );
};

export { CreateClientForm };
